export const SUBURBAN_COMBINE_SEARCH = 'sub_desktop_hom_811_combine_search';

export const EXPERIMENTS: string[] = [SUBURBAN_COMBINE_SEARCH];
